
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"125","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2208"}},[_c('path',{attrs:{"data-name":"Rectangle 2932","fill":"none","d":"M0 0h125v120H0z"}}),_c('path',{attrs:{"data-name":"Path 1332","d":"M125 120V52.516L94.242 21.758A6 6 0 0084 26v18.141L61.617 21.758A6 6 0 0051.375 26 7.688 7.688 0 1136 26a6 6 0 00-12 0 19.65 19.65 0 0013.687 18.657v30.691A19.647 19.647 0 0024 94a5.982 5.982 0 001.758 4.243L47.516 120z","fill":"#727272"}}),_c('g',{attrs:{"data-name":"Group 2207","fill":"#d5d5d5"}},[_c('path',{attrs:{"data-name":"Path 1333","d":"M63.375 26a6 6 0 00-12 0A7.688 7.688 0 1136 26a6 6 0 00-12 0 19.65 19.65 0 0013.687 18.657v30.691A19.647 19.647 0 0024 94a6 6 0 0012 0 7.688 7.688 0 0115.375 0 6 6 0 0012 0 19.647 19.647 0 00-13.688-18.652V44.657A19.649 19.649 0 0063.375 26z"}}),_c('path',{attrs:{"data-name":"Path 1334","d":"M96 64.367V26a6 6 0 00-12 0v38.367a5.984 5.984 0 00-4 5.632v24a6 6 0 006 6h8a6 6 0 006-6v-24a5.984 5.984 0 00-4-5.632z"}})])])])
          )
        }
      }
    